import { Button } from '@/components/ui/button'
import type { DetailLevel } from './types'

interface DetailLevelToggleProps {
  value: DetailLevel
  onChange: (level: DetailLevel) => void
}

const LEVELS: { key: DetailLevel; label: string }[] = [
  { key: 'L1', label: 'Overview' },
  { key: 'L2', label: 'Services' },
  { key: 'L3', label: 'Stacking' },
]

export function DetailLevelToggle({ value, onChange }: DetailLevelToggleProps) {
  return (
    <div className="inline-flex items-center gap-0.5 rounded-lg border bg-muted p-0.5">
      {LEVELS.map(({ key, label }) => (
        <Button
          key={key}
          variant={value === key ? 'secondary' : 'ghost'}
          size="sm"
          className="h-6 px-2.5 text-[11px] font-semibold"
          onClick={() => onChange(key)}
        >
          {key} {label}
        </Button>
      ))}
    </div>
  )
}
